import * as React from "react";
import { SVGProps } from "react";

export const IconScheduled = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={18}
    height={20}
    viewBox="0 0 18 20"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M13.53 10.06L12.47 9l-4.88 4.88-2.12-2.12-1.06 1.06L7.59 16l5.94-5.94zM16 2h-1V0h-2v2H5V0H3v2H2C.89 2 .01 2.9.01 4L0 18a2 2 0 002 2h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm0 16H2V7h14v11z"
      fill="currentColor"
    />
  </svg>
);
